<div class="pointer-events-auto relative isolate z-30 size-12 place-items-center select-none">
  @if (togglable()) {
    <!-- slot -->
    <div
      class="absolute inset-1 -z-10 cursor-pointer rounded-lg border-3 border-dashed"
      [class]="{ EMERALD: 'border-emerald-500', BLUE: 'border-blue-500', PINK: 'border-pink-500' }[color()]"
      (click)="toggled.emit()"
    ></div>
  }

  <!-- value -->
  @let v = value();
  @if (v !== undefined) {
    <div
      class="pointer-events-none relative isolate size-12 overflow-hidden rounded-lg p-2"
      [class]="{ EMERALD: 'bg-emerald-500', BLUE: 'bg-blue-500', PINK: 'bg-pink-500' }[color()]"
      animate.enter="anim-pop-in"
      animate.leave="anim-pop-out"
    >
      <div class="absolute inset-0 p-2">
        <img [src]="typeof v === 'string'? v : `/dice/${v + 1}.png`" alt="" />
      </div>
      <div
        class="absolute inset-0 z-10 rounded-lg border-3"
        [class]="{ EMERALD: 'border-emerald-500', BLUE: 'border-blue-500', PINK: 'border-pink-500' }[color()]"
        style="filter: brightness(0.8)"
      ></div>
    </div>
  }
</div>
